import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ButtonBar = ({ schema, active, handleClick, small }) => {
  const smallClassName = small ? "small" : "";
  return (
    <div className={`button-bar__container ${smallClassName}`}>
      {schema &&
        schema.map(({ id, label, icon }) => {
          const activeClassName = id === active ? "active" : "";
          return (
            <button
              type="button"
              key={id}
              className={`button-bar__button ${smallClassName} ${activeClassName}`}
              onClick={() => handleClick(id)}
            >
              {icon && (
                <FontAwesomeIcon className="button-bar__icon" icon={icon} />
              )}
              {label}
            </button>
          );
        })}
    </div>
  );
};

ButtonBar.defaultProps = {
  small: false,
};

ButtonBar.propTypes = {
  schema: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleClick: PropTypes.func.isRequired,
  small: PropTypes.bool,
};
export default ButtonBar;
